import { render, staticRenderFns } from "./BoldReportViewer.vue?vue&type=template&id=037159be&"
import script from "./BoldReportViewer.vue?vue&type=script&lang=js&"
export * from "./BoldReportViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports